import React, { useState } from 'react';
import { Button } from 'components/ui';
import { Controller, useForm } from 'react-hook-form';
import { Input, Modal, Switch } from 'antd';
import { joiResolver } from '@hookform/resolvers/joi';
import * as Joi from 'joi';
import { useRegisterNewDomain } from '../../../../mutation/domain-warmup';

const schema = Joi.object().keys({
  name: Joi.string().required(),
  sgAccount: Joi.string()
    .valid('main', 'alternate')
    .required(),
  ipPool: Joi.string()
    .allow('')
    .optional(),
  dailyLimit: Joi.number()
    .integer()
    .min(0),
});

export default function CreateNewDomainButton() {
  const { mutateAsync, isLoading } = useRegisterNewDomain();
  const [showModal, setShowModal] = useState(false);
  const { control, handleSubmit, reset, formState } = useForm({
    mode: 'onChange',
    defaultValues: {
      name: '',
      sgAccount: 'main',
      ipPool: '',
      dailyLimit: 0,
    },
    resolver: joiResolver(schema),
  });
  return (
    <>
      <Button style={{ marginBottom: 10 }} onClick={() => setShowModal(true)}>
        Create New Domain
      </Button>
      <Modal
        okButtonProps={{
          disabled: !formState.isValid,
          loading: isLoading,
        }}
        title="Create new Domain"
        visible={showModal}
        onCancel={() => setShowModal(false)}
        onOk={handleSubmit(async values => {
          await mutateAsync({
            ...values,
            isWarmedUp: false,
          });
          setShowModal(false);
          reset();
        })}
      >
        <i>New Domain will be marked as Pre Warmed-up</i>
        <div className="space-y-4" style={{ marginTop: 10 }}>
          <Controller
            control={control}
            name="name"
            render={({ field: { value, onChange, onBlur } }) => {
              return (
                <div>
                  <p className="input-name">Domain</p>
                  <Input
                    placeholder="turing.com"
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                  />
                </div>
              );
            }}
          />
          <Controller
            control={control}
            name="sgAccount"
            render={({ field: { value, onChange } }) => {
              const isMain = value === 'main';
              return (
                <div>
                  <p className="input-name">Sendgrid Account</p>
                  <div
                    className="flex items-center space-x-2"
                    style={{ marginTop: 5 }}
                  >
                    <p
                      style={{
                        marginBottom: 0,
                        fontWeight: !isMain ? 'bold' : 'normal',
                      }}
                    >
                      Alternate
                    </p>

                    <Switch
                      checked={value === 'main'}
                      onClick={() => onChange(isMain ? 'alternate' : 'main')}
                    />
                    <p
                      style={{
                        marginBottom: 0,
                        fontWeight: isMain ? 'bold' : 'normal',
                      }}
                    >
                      Main
                    </p>
                  </div>
                </div>
              );
            }}
          />
          <Controller
            control={control}
            name="ipPool"
            render={({ field: { value, onChange, onBlur } }) => {
              return (
                <div>
                  <p className="input-name">IP Pool Name</p>
                  <Input
                    placeholder="IP Pool Name"
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                  />
                </div>
              );
            }}
          />
          <Controller
            control={control}
            name="dailyLimit"
            render={({ field: { value, onChange, onBlur } }) => {
              return (
                <div>
                  <p className="input-name">Daily Limit</p>
                  <Input
                    placeholder="Daily Limit"
                    type="number"
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                  />
                </div>
              );
            }}
          />
        </div>
      </Modal>
    </>
  );
}
